"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const array_1 = require("./../utils/array");
exports.ViewMode = array_1.stringsToEnum(['table', 'cards', 'map']);



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/models/ViewMode.ts
// module id = 249
// module chunks = 0